import * as React from 'react';
import './index.scss';
import { fetch, AreaInfo, RankItem, AuditionRankRsp } from '@pubts/fetch.ts';
import RankHeader from '@webhooks//public/rankHeader.tsx';
import Page from '@webhooks//public/page.tsx';
import AnchorItem from '@webhooks/public/anchorItem.tsx';
import NoneData from '@webhooks//public/none.tsx';
import { None, WebAnchorItem, WithPage, WebAnchorItemDesc } from '@huyafed/comp'
interface Props extends AreaInfo {
  data: any,
  sMatchDesc: string,
}

const Rank1: React.FC<Props> = props => (
  <div className='rank1' id={'area-' + props.data.iAreaId}>
    <i className={`rank-title-${props.data.iAreaId}`} />
    <p className='rank-desc'>{props.sMatchDesc}</p>
    <WebAnchorItemDesc
      width={860}
      color="#f6d94a"
      descs={['排名', '主播昵称', '总里程']}
    />
    <div className='rank-List'>
      {
        props.data.length === 0 ?
          <None text={'暂无数据'} color={'#ffffff'} />
          :
          props.data.map((item: RankItem, idx: number) => (

            <WebAnchorItem
              width={870}
              canJump={true}
              isLarge={true}
              color={'#ffffff'}
              borderColor={'#0f257e'}
              key={idx}
              msg={{ ...item, tJump: { ...item.tJump, bIsLive: item.tJump.iIsLive }, sNickName: item.sNickName, sLogoUrl: item.sLogoUrl }}
            />
          ))
      }
    </div>
    {props.children}
  </div>
)
export default WithPage(Rank1);